var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHolisticEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_57",
    "data-name": "Group 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.94,
    height: 84.95,
    viewBox: "0 0 65.94 84.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 65.94,
    height: 84.95,
    fill: "#e68242"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M12.02,114.842c-6.487.141-8.887-8.544-3.309-11.865.742-.442,2.342-.741,2.742-1.247a1.352,1.352,0,0,0-.472-2.046c-1.658-.67-5.37,2-6.27,3.458l-.176.006A7.837,7.837,0,0,1,.522,93.128c1.2-3.268,5.339-5.964,8.728-4.176,1.048.553,2.125,2.6,3.363,1.144,1.6-1.884-2.778-3.964-4.239-4.257a8.948,8.948,0,0,0-2.485-.091C3.576,79.816,11.518,74.358,16.16,78.72c.655.616,1.2,2.112,2.255,2.074a1.593,1.593,0,0,0,1.165-.68c.825-1.811-2.94-4.521-4.406-5.071,2.08-4.642,9.141-3.386,9.643,1.669l-.041,38.836c-.07.928-1.183,3.152-2.069,3.415a40.523,40.523,0,0,1-5.458.042c-1.784-.162-2.767-3-2.553-4.563.261-1.912,2.239-1.945,2.445-2.877.337-1.526-1-2-2.277-1.441a5.4,5.4,0,0,0-2.844,4.717",
    transform: "translate(-0.001 -56.169)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M145.557,114.284h-7.313v-47.1a2.8,2.8,0,0,1,.579-.751c.908-.713,3.484-.064,4.609.217C156.846,69.986,163.057,86.2,155.6,97.821c-2.122,3.307-5.489,5.324-7.516,8.769a19.018,19.018,0,0,0-2.525,7.694m-2.538-43.5a1.361,1.361,0,0,0-.766,2.025c.234.412,3.1,1.627,3.855,2.127a14.475,14.475,0,0,1,6.078,9.708c.158.9-.162,2.918.968,3.184,2.392.564,1.882-2.207,1.665-3.657a17.132,17.132,0,0,0-9.981-12.951,3.057,3.057,0,0,0-1.819-.437",
    transform: "translate(-107.609 -51.456)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M54.119,330.054l29.3-.032c2.181,1.436.733,5.3-1.673,5.631l-25.414.015a3.5,3.5,0,0,1-2.209-5.614",
    transform: "translate(-41.565 -256.889)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M54.172,299.628c-1.556-2.031-.412-5.331,2.209-5.614l25.248.015c2.581.351,4.092,4.023,1.839,5.631Z",
    transform: "translate(-41.618 -228.86)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M99.858,366a4.171,4.171,0,0,1-3.447,3.616,73.1,73.1,0,0,1-10.936.047A4.451,4.451,0,0,1,81.244,366Z",
    transform: "translate(-63.24 -284.891)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M214.33,234.225a2.044,2.044,0,0,1,1.056.535,59.5,59.5,0,0,1,5.978,5.986c1.111,1.483-.349,2.983-1.817,1.982a68.865,68.865,0,0,1-6.159-6.137c-.757-1.048-.384-2.325.942-2.366",
    transform: "translate(-165.8 -182.321)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M220.344,45.115a1.372,1.372,0,0,1,1.5.758c.378.753.059,1.089-.391,1.691a54.671,54.671,0,0,1-5.807,5.825c-1.511,1.16-2.879.169-2.248-1.583,1.328-.9,5.864-6.467,6.945-6.691",
    transform: "translate(-165.987 -35.095)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M134.065.405a2.159,2.159,0,0,1,.39,1.024c.305,2.727-.228,6.012-.014,8.8a1.362,1.362,0,0,1-2.646.172c.3-2.836-.419-6.566.006-9.291a1.331,1.331,0,0,1,2.264-.705",
    transform: "translate(-102.487 0)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M247.2,153.876l9.428-.025c1.314.209,1.494,2.424-.488,2.648-2.678.3-5.895-.217-8.633-.009-1.4-.335-1.8-2.073-.306-2.614",
    transform: "translate(-191.679 -119.758)",
    fill: "#e68242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolisticEducation);
export default __webpack_public_path__ + "static/media/holistic_education.8f63d617599075b02f08f7ecaa1450eb.svg";
export { ForwardRef as ReactComponent };